export default class VitalsSummaryHelpers {
	public static canScoreVitalsTest = (
		completedTasks: VitalsCompletedTasksDTO[]
	): boolean => {
		//determine if I can save by the following rules
		//1. at least 3 tasks must be performed.
		//2. if only 3 tasks, it must be task 1, 3 and 5
		//3. if 4 or more tasks done, it doesn't matter which
		/*4. tasks are done based on these conditions:
		  4a. task 1 (rt) must have the second task complete (task 1 is practice)
		  4b. task 2 (ufv) must have task 2 and 4 complete (task 1 and 3 are practice)
		  4c. task 3 (gap) must have task 2 complete (task 1 is practice)
		  4d. task 4 (attn) must have task 2 and 3 complete (task 1 is practice)
		  4e. task 5 (swm) must have task 1 and 2 complete (no practice)
		  4f. task 6 (vid) must have task 2 complete (task 1 is practice)
		*/
		const TaskComplete = (type: string) => {
			const taskMap: { [type: string]: Array<number> } = {};
			taskMap["rt"] = [2];
			taskMap["ufv"] = [2, 4];
			taskMap["gap"] = [2];
			taskMap["attn"] = [2, 3];
			taskMap["swm"] = [1, 2];
			taskMap["vid"] = [2];

			let taskNums = taskMap[type];

			//the task type with all specified tasknums must exist, and numreceived must equal numtrials
			let complete = taskNums.every(
				(t) =>
					completedTasks.find(
						(c) =>
							c.type === type && c.task === t && c.numTrials === c.numReceived
					) !== undefined
			);

			return complete;
		};

		const distinctTaskTypes = Array.from(
			new Set(
				completedTasks.map(
					(item: VitalsCompletedTasksDTO) => item.type as string
				)
			)
		);

		/* rather than check if there are more than 3 distinct task types in the "completed" task list,
		   I need to check if there are more than 3 fully completed tasks */

		const totalFullyCompleteTaskCount = distinctTaskTypes.reduce(
			(previousCount: number, currentValue: string) => {
				return TaskComplete(currentValue) ? previousCount + 1 : previousCount;
			},
			0
		);

		if (totalFullyCompleteTaskCount > 3) {
			//more than 3 tasks
			return true;
		} else if (totalFullyCompleteTaskCount == 3) {
			//this is where I need to validate that the 3 required tasks are complete
			return TaskComplete("rt") && TaskComplete("gap") && TaskComplete("swm");
		} else {
			return false;
		}
	};
}
